require('./cardRequestAdditional.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');

// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { nonNumericFilter, toFirstUppercase } = require('utilities/stringHelper');
const { formatCardContract } = require('utilities/cardsHelper');

// @ constants
const { WIZARD_VERTICAL_VIEW_MODE, FIRST_STEP, SECOND_STEP } = require('constants/index');
const { CARD_REQUEST_ADDITIONAL } = require('constants/contactCenter/operationTypes');
const {
    ERROR_CARD_REQUEST_ADDITIONAL_NO_INTERVENERS,
    ERROR_CARD_REQUEST_ADDITIONAL_RELATIONSHIP_ALREADY_EXISTS
} = require('constants/contactCenter/errorTypes');

// @ components
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const { LoadingSection } = require('commonsComponents/loadingSection');
const CustomCardDetails = require('components/contactCenter/customCardDetails/customCardDetails');
const ContractInfo = require('components/contactCenter/contractInfo/contractInfo');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const CardRequestAdditionalStep1 = require('components/contactCenter/cardRequestAdditional/cardRequestAdditionalStep1/cardRequestAdditionalStep1');
const CardRequestAdditionalStep2 = require('components/contactCenter/cardRequestAdditional/cardRequestAdditionalStep2/cardRequestAdditionalStep2');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');
const { ModalCustom } = require('commonsComponents/modalCustom');
const { printGenericDocument } = require('components/contactCenter/printer');
const { OKButton } = require('components/commons/OKButton/OKButton');

class CardRequestAdditional extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleSelectIntervener = this.handleSelectIntervener.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.backToCards = this.backToCards.bind(this);
        this.handleToggleCancelModal = this.handleToggleCancelModal.bind(this);
        this.handleToggleShowModalError = this.handleToggleShowModalError.bind(this);
        this.handleOnRequestCloseModalError = this.handleOnRequestCloseModalError.bind(this);
        this.hasInterveners = this.hasInterveners.bind(this);
        this.state = {
            showModal: false,
            showModalError: false
        };
    }

    componentDidMount() {
        const { match: { params: { cardId } }, queryRequestAdditionalCardData } = this.props;

        queryRequestAdditionalCardData(cardId);
    }

    componentWillReceiveProps(nextProps) {
        const validateErrorNext = nextProps.immCardRequestAdditional.get('validateError');

        if (validateErrorNext) {
            this.handleToggleShowModalError();
        }
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    handleSelectIntervener(intervenerId) {
        const { selectIntervener } = this.props;

        selectIntervener(intervenerId);
    }

    handleFinish() {
        const { match: { params: { cardId } }, handleFinish } = this.props;

        handleFinish(cardId);
    }

    handleCancel() {
        const { cardId } = this.props.match.params;

        this.props.history.push(`/myprofile/cards/${cardId}/movements`);
    }

    handleToggleCancelModal() {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    handleToggleShowModalError() {
        this.setState({
            showModalError: !this.state.showModalError
        });
    }

    hasInterveners() {
        const { immCardRequestAdditional } = this.props;
        const interveners = immCardRequestAdditional.getIn(['steps', FIRST_STEP, 'interveners']).toJS();

        return interveners.length > 0;
    }

    backToCards() {
        this.props.history.push('/myprofile/cards');
    }

    buildErrorFeedback(errorType) {
        const title = formatText('cardRequestAdditional-feedbackErrorTitle');
        let subtitle = formatText('cardRequestAdditional-feedbackErrorSubtitle');

        if (errorType === ERROR_CARD_REQUEST_ADDITIONAL_RELATIONSHIP_ALREADY_EXISTS) {
            subtitle = formatText('cardRequestAdditional-feedbackErrorRelationshipAlreadyExists');
        } else if (__CONTACT_CENTER__ && errorType === ERROR_CARD_REQUEST_ADDITIONAL_NO_INTERVENERS) {
            subtitle = formatText('cardRequestAdditional-feedbackErrorSubtitleNoOwner');
        }

        const textLink = formatText('cardRequestAdditional-backToCards');

        return (
            <div className="card-request-additional__feedback">
                <CustomMessageBox
                    icon="icon-warning"
                    title={title}
                    subtitle={subtitle}
                    textLink={textLink}
                    goBackHandler={this.backToCards}
                />
            </div>
        );
    }

    buildSuccessFeedback() {
        const title = formatText('cardRequestAdditional-feedbackSuccessTitle');
        const subtitle = formatText('cardRequestAdditional-feedbackSuccessSubtitle');
        const textLink = formatText('cardRequestAdditional-backToCards');

        return (
            <div className="card-request-additional__feedback">
                <CustomMessageBox
                    icon="icon-success"
                    title={title}
                    subtitle={subtitle}
                    textLink={textLink}
                    goBackHandler={this.backToCards}
                />
            </div>
        );
    }

    buildLoadingSection() {
        return (
            <div className="card-request-additional__loading-section">
                <LoadingSection />
            </div>
        );
    }

    buildPreleaveCancelModal() {
        return (
            <PreleaveCancelModal
                isOpen={this.state.showModal}
                onCancel={this.handleCancel}
                onCloseModal={this.handleToggleCancelModal}
                onStayHere={this.handleToggleCancelModal}
            />
        );
    }

    handleOnRequestCloseModalError() {
        this.handleToggleShowModalError();
        this.props.clearValidationRequest();
    }

    formatModalErrorMessage(errorMessage) {
        if (!errorMessage) {
            return '';
        }

        // toFirstUppercase doesn't work with strings with less than 2 characters
        if (errorMessage.length < 3) {
            return errorMessage;
        }

        return toFirstUppercase(errorMessage);
    }

    buildErrorValidate() {
        const { immCardRequestAdditional } = this.props;
        const title = formatText('cardRequestAdditional-modalErrorTitle');
        const validationErrorMessage = this.formatModalErrorMessage(immCardRequestAdditional.get('validateErrorMessage', ''));

        return (
            <ModalCustom
                shouldCloseOnOverlayClick={false}
                isOpen={this.state.showModalError}
                extraClass="card-request-additional__modal"
                onRequestClose={this.handleOnRequestCloseModalError}
            >
                <header className="card-request-additional__modal-header">
                    <span className="card-request-additional__modal-title">{title}</span>
                </header>
                <section className="card-request-additional__section">
                    <p className="card-request-additional__modal-message">
                        <span>
                            <i className="card-request-additional__modal-icon icon-error" />
                        </span>
                        <span className="card-request-additional__modal-body">
                            {validationErrorMessage}
                        </span>
                    </p>
                </section>
                <footer className="card-request-additional__modal-footer">
                    <OKButton onClick={this.handleOnRequestCloseModalError}>
                        <FormattedText value="cardRequestAdditional-modalCloseButtonText" />
                    </OKButton>
                </footer>
            </ModalCustom>
        );
    }

    buildWizard() {
        const { match: { params: { cardId } }, immAccounts, immCards, immCardRequestAdditional, validateStep, setVisibleStep } = this.props;
        const immSteps = immCardRequestAdditional.get('steps');
        const immCard = immCards.get('byId').get(cardId);
        const immFirstStep = immSteps.get(FIRST_STEP);
        const immSecondStep = immSteps.get(SECOND_STEP);
        const isFetchingValidate = immCardRequestAdditional.get('isFetchingValidate');
        const isSaving = immCardRequestAdditional.get('isSaving');

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel: () => { },
            finish: this.handleFinish,
            cancel: this.handleToggleCancelModal,
        };

        const originAccount = formatCardContract(immCard);
        const pan = nonNumericFilter(immCard.get('number'));

        const operationParams = {
            originAccount,
            pan
        };

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immCardRequestAdditional.get('visibleStep')}
                wizardClass="card-request-additional__wizard"
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    isLoading={isFetchingValidate}
                >
                    <CardRequestAdditionalStep1
                        immAccounts={immAccounts}
                        immStep={immFirstStep}
                        onSelectIntervener={this.handleSelectIntervener}
                    />
                </WizardStep>
                <WizardStep
                    position="middle"
                    omitPreviousButton={true}
                    cancelButton={true}
                >
                    <CardRequestAdditionalStep2
                        immCard={immCard}
                        immStep={immSecondStep}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    omitPreviousButton={true}
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={isSaving}
                    immFinalButton="cardRequestAdditional-confirm"
                >
                    <VerifyOtpStep
                        operationType={CARD_REQUEST_ADDITIONAL}
                        operationParams={operationParams}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildBodyContent(immCard) {
        const { immCardRequestAdditional } = this.props;
        const isLoading = !immCard || !immCardRequestAdditional || immCardRequestAdditional.get('isFetching') || !immCardRequestAdditional.get('fetched');

        if (isLoading) {
            return this.buildLoadingSection();
        }

        const fetchError = immCardRequestAdditional.get('fetchError');
        const saveSuccessful = immCardRequestAdditional.get('saveSuccessful');
        const saveError = immCardRequestAdditional.get('saveError');
        const saveErrorType = immCardRequestAdditional.get('saveErrorMessage');

        if (fetchError) {
            return this.buildErrorFeedback();
        }

        if (saveError) {
            return this.buildErrorFeedback(saveErrorType);
        }

        if (saveSuccessful) {
            return this.buildSuccessFeedback();
        }

        if (__CONTACT_CENTER__ && !this.hasInterveners()) {
            return this.buildErrorFeedback(ERROR_CARD_REQUEST_ADDITIONAL_NO_INTERVENERS)
        }

        const title = formatText('cardRequestAdditional-title');
        const wizard = this.buildWizard(immCard);
        const modal = this.buildPreleaveCancelModal();
        const validationErrorModal = this.buildErrorValidate();

        return (
            <div className="row no-outside-gutter">
                <div className="card-request-additional__title">
                    {title}
                </div>
                <div className="card-request-additional__wizard-column col-xs-8">
                    <section className="card-request-additional__wizard-container">
                        {wizard}
                        {modal}
                        {validationErrorModal}
                    </section>
                </div>
                <div className="card-request-additional__card-details-column col-xs-4">
                    <CustomCardDetails immCard={immCard} />
                    <ContractInfo immCard={immCard} />
                </div>
            </div>
        );
    }

    render() {
        const { match: { params: { cardId } }, immCards } = this.props;
        const immCard = immCards.get('byId').get(cardId);

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.get('alias').get('current'),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('cardRequestAdditional-title'),
                url: ''
            }
        ];

        const bodyContent = this.buildBodyContent(immCard);
        printGenericDocument(bodyContent)
        return (
            <section className="card-request-additional">
                <OKHeaderCC
                    title="cardRequestAdditional-title"
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                />
                <div className="card-request-additional__body">
                    {bodyContent}
                </div>
            </section>
        );
    }
}

CardRequestAdditional.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCardRequestAdditional: PropTypes.object.isRequired,
    immPrinter: PropTypes.object.immPrinter,
    queryRequestAdditionalCardData: PropTypes.func.isRequired,
    selectIntervener: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    clearValidationRequest: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
};

module.exports = withRouter(CardRequestAdditional);
